import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--left",
  "use": "icon-chevron--left-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 11\" id=\"icon-chevron--left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.177 4.677a.503.503 0 0 0 0 .765L4.702 9.97a.5.5 0 1 0 .707-.707L1.208 5.06 5.41.857A.5.5 0 1 0 4.703.15L.177 4.677Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol